import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FIELD_INTERVENTION_CONTROL_RESULTS_COLUMN_WIDTHS } from '@connect-services/client/components/field-intervention-form-entity-control-results/field-intervention-form-entity-control-results.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-field-intervention-form-entity-control-results-header',
    styleUrl: './../field-intervention-form-entity-control-results.component.scss',
    templateUrl: './field-intervention-form-entity-control-results-header.component.html',
})
export class FieldInterventionFormEntityControlResultsHeaderComponent {
    protected readonly columnWidthClasses = FIELD_INTERVENTION_CONTROL_RESULTS_COLUMN_WIDTHS;
}
